'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _discover = require('redux/modules/discover');

var _outfeat = require('redux/modules/outfeat');

var _auth = require('redux/modules/auth');

var _instagram = require('redux/modules/instagram');

var _user = require('redux/modules/user');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OUTFEAT_BASE_ROUTE = '/';
var SSR_OUTFEAT_BASE_ROUTE = '/o';

exports.default = function (store) {
  var findOutfeat = function findOutfeat(nextState, replace, cb) {
    var state = store.getState();
    var outfeatId = void 0;
    if (state && state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname) {
      outfeatId = state.routing.locationBeforeTransitions.pathname.replace(OUTFEAT_BASE_ROUTE, '');
      store.dispatch((0, _outfeat.find)(outfeatId));
    }
    cb();
  };

  var findCanonicalOutfeat = function findCanonicalOutfeat(nextState, replace, cb) {
    var state = store.getState();
    var outfeatId = void 0;
    if (state && state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname) {
      var idx = state.routing.locationBeforeTransitions.pathname.indexOf(OUTFEAT_BASE_ROUTE);
      if (idx != -1) {
        outfeatId = state.routing.locationBeforeTransitions.pathname.substring(SSR_OUTFEAT_BASE_ROUTE.length);
        store.dispatch((0, _outfeat.find)(outfeatId));
      } else {
        outfeatId = state.routing.locationBeforeTransitions.pathname.substring(SSR_OUTFEAT_BASE_ROUTE.length);
        store.dispatch((0, _outfeat.find)(outfeatId));
      }
    }
    if (__SERVER__ && outfeatId) {
      (0, _outfeat.findSync)(outfeatId).then(function (outfeat) {
        cb(null, null, outfeat);
        store.dispatch((0, _outfeat.outfeatFound)(outfeat));
      });
    } else {
      cb();
    }
  };

  var fetchDiscover = function fetchDiscover(nextState, replace, cb) {
    var state = store.getState();
    store.dispatch((0, _discover.fetchPopular)(false));
    cb();
  };

  var fetchAdminDiscover = function fetchAdminDiscover(nextState, replace, cb) {
    var state = store.getState();
    store.dispatch((0, _discover.fetchPopular)(true));
    cb();
  };

  var enterLogin = function enterLogin(nextState, replace, cb) {
    var state = store.getState();
    if (state.auth.user.id) {
      replace('@' + state.auth.user.username);
    }
    cb();
  };

  var enterCanonicalProfile = function enterCanonicalProfile(nextState, replace, cb) {
    var state = store.getState();
    var username = state.routing.locationBeforeTransitions.pathname.replace('u/@', '').replace('/', '');
    if (__SERVER__ && username) {
      (0, _user.getUserOutfeats)(username).then(function (result) {
        cb(null, null, result);
        store.dispatch((0, _user.userOutfeatFound)(result));
      }, function (err) {
        console.log(err);
        cb();
      });
    } else {
      store.dispatch((0, _user.loadUserOutfeats)(username));
      cb();
    }
  };
  var enterProfile = function enterProfile(nextState, replace, cb) {
    if (!__SERVER__) {
      var state = store.getState();
      var username = state.routing.locationBeforeTransitions.pathname.replace('@', '').replace('/', '');
      store.dispatch((0, _user.loadUserOutfeats)(username));
    }
    cb();
  };

  var enterLoginSuccess = function enterLoginSuccess(nextState, replace, cb) {
    var _store$getState = store.getState();

    var routing = _store$getState.routing;

    if (routing && routing.locationBeforeTransitions && routing.locationBeforeTransitions.query && routing.locationBeforeTransitions.query.access_token) {
      store.dispatch((0, _auth.load)(routing.locationBeforeTransitions.query.access_token));
    }
    cb();
  };

  var fetchInstagram = function fetchInstagram(nextState, replace, cb) {
    if (!__SERVER__ && nextState.auth && nextState.auth.access_token) {
      setTimeout(function () {
        store.dispatch((0, _instagram.loadRecentInstagramPosts)());
      }, 100);
    }
    cb();
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: 'create', onEnter: fetchInstagram, component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: 'discover', onEnter: fetchDiscover, component: _containers.Discover }),
    _react2.default.createElement(_reactRouter.Route, { path: '/admin/discover', onEnter: fetchAdminDiscover, component: _containers.AdminDiscover }),
    _react2.default.createElement(_reactRouter.Route, { path: 'LoginSuccess', onEnter: enterLoginSuccess, component: _containers.LoginSuccess }),
    _react2.default.createElement(_reactRouter.Route, { path: 'terms', component: _containers.Terms }),
    _react2.default.createElement(_reactRouter.Route, { path: '/@:username', onEnter: enterProfile, component: _containers.Profile }),
    _react2.default.createElement(_reactRouter.Route, { path: '/u/@:username', onEnter: enterCanonicalProfile, component: _containers.Profile }),
    _react2.default.createElement(_reactRouter.Route, { path: '/:outfeatId', onEnter: findOutfeat, component: _containers.Outfeat }),
    _react2.default.createElement(_reactRouter.Route, { path: '/o/:outfeatId', onEnter: findCanonicalOutfeat, component: _containers.Outfeat }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1123
 ** module chunks = 0
 **/